<template>
  <div class="cal__header">
    <div class="cal__header_btn cal__header_btn1"></div>
    <div class="cal__header_btn cal__header_btn2"></div>
    <div class="cal__header_btn cal__header_btn3"></div>
    <div class="cal__header_simulation">Simulation<br>en 3 minutes.</div>
    <div class="cal__header_content">
      <div class="cal__header_title cal__font_bree">Calculateur d’enveloppe budgétaire</div>
      <div class="cal__header_subtitle">Entrez un nombre de jours et obtenez un budget</div>
    </div>
  </div>  
</template>

<script>
export default {
  name: 'AppHeader'
}
</script>